package one.healthium.tasks.ui

import androidx.compose.runtime.Immutable
import loco.DAILY_TASKS_COMPLETED_TASKS_SECTION
import loco.DAILY_TASKS_TO_DO_TASKS_SECTION
import one.healthium.loco.asLString
import one.healthium.tasks.domain.DailyTaskModel

@Immutable
data class DailyTasksUiModel(
    private val tasks: List<DailyTaskModel>? = null,
) {
    val uiData = if (tasks != null) {
        buildList {
            val todoTasks = mutableListOf<DailyTaskModel>()
            val completedTasks = mutableListOf<DailyTaskModel>()

            tasks.forEach {
                if (it.completed) {
                    completedTasks.add(it)
                } else {
                    todoTasks.add(it)
                }
            }

            if (todoTasks.isNotEmpty()) {
                add(loco.Res.string.DAILY_TASKS_TO_DO_TASKS_SECTION.asLString())
                addAll(todoTasks)
            }
            if (completedTasks.isNotEmpty()) {
                add(loco.Res.string.DAILY_TASKS_COMPLETED_TASKS_SECTION.asLString())
                addAll(completedTasks)
            }
        }
    } else {
        emptyList()
    }
}